import cookie from '@/app/js/helpers/cookie'
import {isInViewport} from '@/app/js/helpers/isInViewport'

const defaultCurrency = document.querySelector('[name="application-default-currency"]')?.content

export const analytics = {
  PAYMENT_METHODS: {
    STRIPE: 'card',
    PAYPAL: 'paypal',
    AMAZON: 'amazon',
  },

  productDetail({name, id, price, list}) {
    window.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'Ecommerce',
      'eventAction': 'view_item',
      'ecommerce': {
        'currencyCode': defaultCurrency,
        'view_items': {
          'actionField': {
            'list': list
          },
          'products': [{
            'id': id, //product_id
            'name': name, //product_name
            'category': name, //product_category
            'price': price, // point is important
          }]
        }
      }
    })

    window.dataLayer.push({
      event: 'gtagDynRem',
      dynRemEventName: 'view_item',
      dynRemValue: price,
      dynRemItems: [
        {
          'id': id,
          'google_business_vertical': 'retail'
        },
      ],
      dynRemFBItems: [id],
    })
  },
  productsDetail(items) {
    window.dataLayer.push({
      'event': 'view_item_list',
      'ecommerce': {
        items,
        'currencyCode': defaultCurrency,
      }
    })

    const ids = []
    let total = 0
    items.forEach(item => {
      ids.push(item.item_id)
      total += item.price
    })

    window.dataLayer.push({
      event: 'gtagDynRem',
      dynRemEventName: 'view_item_list',
      dynRemValue: total,
      dynRemItems: ids.map(id => {
        return {
          id,
          'google_business_vertical': 'retail'
        }
      }),
      dynRemFBItems: ids,
    })
  },
  productAddToCart(productInfo, quantity) {
    window.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'Ecommerce',
      'eventAction': 'addToCart',
      'ecommerce': {
        'currencyCode': defaultCurrency,
        'add': {
          'products': [{
            'id': productInfo.product_id.toString(), //product_id
            'name': productInfo.name, //product_name
            'category': productInfo.name, //product_category
            'price': productInfo.price, // point is important
            'quantity': quantity
          }]
        }
      }
    })

    window.dataLayer.push({
      event: 'gtagDynRem',
      dynRemEventName: 'add_to_cart',
      dynRemValue: productInfo.price,
      dynRemItems: [
        {
          'id': productInfo.product_id.toString(),
          'google_business_vertical': 'retail'
        },
      ],
      dynRemFBItems: [productInfo.product_id.toString()],
    })

    fetch(`index.php?route=module/klaviyo/added_to_cart&pid=${productInfo.product_id}&quantity=${quantity}`)
      .then((r) => r.json())
      .then((json) => {
        if (json['klaviyo_addtocart_items']) {
          console.log(json['klaviyo_addtocart_items'])
          window._learnq.push(['track', 'Added to Cart', json['klaviyo_addtocart_items']])
        }
      })
  },
  productRemoveFromCart(productInfo, quantity) {
    window.dataLayer.push({
      'event': 'remove_from_cart',
      'ecommerce': {
        'currencyCode': defaultCurrency,
        'items': [{
          item_id: productInfo.product_id.toString(),
          item_name: productInfo.name,
          affiliation: cookie.getCookie('storeName'),
          currency: defaultCurrency,
          index: 1,
          item_brand: 'EscapeWelt',
          item_category: 'TOWAR',
          item_list_id: '11',
          price: productInfo.price,
          quantity,
        }]
      }
    })
  },
  productClick({name, id, list}) {
    window.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'Ecommerce',
      'eventAction': 'productClick',
      'ecommerce': {
        'currencyCode': defaultCurrency,
        'click': {
          'actionField': {
            'list': list,
          }, // inherits from stage 1
          'products': [{
            'id': id.toString(), //product_id
            'name': name, //product_name
            'category': name, //product_category
          }]
        }
      }
    })
  },
  viewCart(items) {
    window.dataLayer.push({
      'event': 'view_cart',
      'ecommerce': {
        'currencyCode': defaultCurrency,
        items
      }
    })
  },
  onCheckout(items) {
    window.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'Ecommerce',
      'eventAction': 'checkout',
      'ecommerce': {
        'currencyCode': defaultCurrency,
        'checkout': {
          'actionField': {},
          'products': items
        }
      }
    })
  },
  addShippingInfo(shippingInfo, items) {
    window.dataLayer.push({
      'event': 'add_shipping_info',
      'ecommerce': {
        'currencyCode': defaultCurrency,
        'shipping_tier': shippingInfo.title,
        items
      }
    })
  },
  addPaymentInfo(paymentInfo, items) {
    window.dataLayer.push({
      'event': 'add_payment_info',
      'ecommerce': {
        'currencyCode': defaultCurrency,
        'payment_type': paymentInfo.title,
        items
      }
    })
  },
  goToPurchase(items, {id, total, tax, shipping, coupon, currency}) {
    window.dataLayer.push({
      event: 'goToPurchase',
      'ecommerce': {
        transaction_id: id,
        affiliation: cookie.getCookie('storeName'),
        value: total,
        tax,
        shipping,
        currency: currency ?? defaultCurrency,
        coupon,
        items
      }
    })
  },
  purchase(items, {id, total, tax, shipping, coupon, currency}) {
    window.dataLayer.push({
      'ecommerce': {
        transaction_id: id,
        affiliation: cookie.getCookie('storeName'),
        value: total,
        tax,
        shipping,
        currency: currency ?? defaultCurrency,
        coupon,
        items
      }
    })

    window.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'Ecommerce',
      'eventAction': 'purchase',
      'eventLabel': id,
      'eventValue': total,			// purchase amount
      'ecommerce': {
        'currencyCode': defaultCurrency,
        'products': items
      }
    })

    const ids = items.map(item => item.item_id)

    window.dataLayer.push({
      event: 'gtagDynRem',
      dynRemEventName: 'view_item_list',
      dynRemValue: total,
      dynRemItems: ids.map(id => {
        return {
          id,
          'google_business_vertical': 'retail'
        }
      }),
      dynRemFBItems: ids,
    })
  },

  eventPromotion(event, {id, name, slot, location}) {
    window.dataLayer.push({
      'event': event,
      'ecommerce': {
        'currencyCode': defaultCurrency,
        'promotions': [{
          'promotion_id': id, // optional parameter
          'promotion_name': name, // banner name
          'creative_slot': slot, // banner page
          'location_id': location, // promo-banner placement
        }]
      }
    })
  },
  impression({
    id,
    name,
    category,
    list,
    price,
    position,
  }) {
    window.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'Ecommerce',
      'eventAction': 'impression',
      'ecommerce': {
        'currencyCode': defaultCurrency,
        'impressions': [{
          id,
          name,
          category,
          list,
          price,
          position,
        }]
      }
    })
  },
  checkoutPersonalInfoInserted() {
    window.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'Ecommerce',
      'eventAction': 'checkout_delivery_personal_info',
    })
  },
  companyPersonChecked() {
    window.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'Ecommerce',
      'eventAction': 'checkout_delivery_company',
    })
  },
  privatePersonChecked() {
    window.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'Ecommerce',
      'eventAction': 'checkout_delivery_private',
    })
  },
  deliveryAddressConfirmed() {
    window.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'Ecommerce',
      'eventAction': 'checkout_delivery_confirm',
    })
  },
  changePaymentAddressIsIdentical() {
    window.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'Ecommerce',
      'eventAction': 'checkout_payment_address',
    })
  },
  productReviewSent() {
    window.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'feedback_form',
      'eventAction': 'form_questions',
    })
  },
  ajaxFormSent() {
    window.dataLayer.push({
      'event': 'ajax_form_sent',
    })
  },
  phoneClick() {
    window.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'button_click',
      'eventAction': 'phone_click',
    })
  },
  emailClick() {
    window.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'button_click',
      'eventAction': 'email_click',
    })
  },
  promoCodeActivated(code) {
    window.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'Ecommerce',
      'eventAction': 'promocode_activate',
      'ecommerce': {
        'currencyCode': defaultCurrency,
        'promocode': code
      }
    })
  },

  viewInTime(el, milliseconds, callback) {
    const observer = new IntersectionObserver((_, observer) => {
      if (el.dataset.viewInTime === 'viewed') {
        return
      }

      setTimeout(() => {
        if (el.dataset.viewInTime === 'viewed') {
          return
        }

        if (isInViewport(el)) {
          callback()
          observer.unobserve(el)

          el.dataset.viewInTime = 'viewed'
        }
      }, milliseconds)
    })

    observer.observe(el)
  },
  paymentMethodSelected(method) {
    window.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'Ecommerce',
      'eventAction': 'checkout_pay_' + method,
    })
  },
  storeClick() {
    window.dataLayer.push({
      'event': 'autoEvent',
      'eventCategory': 'button_click',
      'eventAction': 'store_click'
    })
  }
}

function handleProductLinks() {
  document.querySelectorAll('.js-product-link').forEach(linkEl => {
    linkEl.addEventListener('click', e => {
      e.preventDefault()

      analytics.productClick({
        name: linkEl.dataset.name,
        id: linkEl.dataset.id,
        price: linkEl.dataset.price,
        list: linkEl.dataset.list,
      })

      location.assign(linkEl.href + '&list=' + linkEl.dataset.list)
    })
  })
}

function handleCategoryProductsImpression() {
  document
    .querySelectorAll('.js-category-product')
    .forEach((product, key) => {
      const firstLink = product.querySelector('.js-product-link')

      analytics.viewInTime(product, 2000, () => analytics.impression({
        id: firstLink.dataset.id,
        name: firstLink.dataset.name,
        category: firstLink.dataset.name,
        list: firstLink.dataset.list,
        price: firstLink.dataset.price,
        position: key + 1,
      }))
    })
}

function handleHomeBannerLinks() {
  document.querySelectorAll('.js-home-main-banner-link').forEach(el => {
    el.addEventListener('click', e => {
      e.preventDefault()

      analytics.eventPromotion('click_promotion', {
        id: 'bts',
        name: 'Home page main banner',
        slot: 'Home page',
        location: 'top',
      })

      location.assign(el.href)
    })
  })
}

function handlePhoneLinks() {
  document.querySelectorAll('.js-phone-link').forEach(el => {
    el.addEventListener('click', () => {
      analytics.phoneClick()
    })
  })
}

function handleEmailLinks() {
  document.querySelectorAll('.js-email-link').forEach(el => {
    el.addEventListener('click', () => {
      analytics.emailClick()
    })
  })
}

function handleChangeStoreLink() {
  document.querySelectorAll('.js-change-store-link').forEach(el => {
    el.addEventListener('click', () => {
      analytics.storeClick()
    })
  })
}

export function initAnalytics() {
  if (!window.dataLayer) {
    window.dataLayer = []
  }

  handleProductLinks()
  handleHomeBannerLinks()
  handlePhoneLinks()
  handleEmailLinks()
  handleCategoryProductsImpression()
  handleChangeStoreLink()
}
